/**
 * Generated by orval v8.23.0 🍺
 * Do not edit manually.
 * Arbi API
 * OpenAPI spec version: 1.0.0
 */
import type { IntegrationCatalogItemCategory } from './integrationCatalogItemCategory';
import type { IntegrationDetailEntry } from './integrationDetailEntry';
import type { IntegrationSyncInfo } from './integrationSyncInfo';

/**
 * Unified shape returned by the catalog endpoint — card fields + detail
 * fields merged so the consumer has everything in one request.
 */
export interface IntegrationCatalogItem {
  id: string;
  name: string;
  description: string;
  domain: string;
  category: IntegrationCatalogItemCategory;
  detail?: IntegrationDetailEntry | null;
  sync?: IntegrationSyncInfo | null;
}
